module.exports = __webpack_public_path__ + "static/services-image-4_d-5f6c5da7a611b3b0390e40a1e5d97c70.jpg";